
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/material-ui/guides/api",
      function () {
        return require("private-next-pages/material-ui/guides/api.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/material-ui/guides/api"])
      });
    }
  